import AuthSlice from "./authSlice"
import ProjectSlice from "./projectSlice"
import SettingSlice from "./settingSlice"
import SubProjectSlice from "./subProjectSlice"
import AboutSlice from "./aboutSlice"
import ContactSlice from "./clientSlice"
import SubMenuSlice from "./subMenuSlice"
// Website
import WebHomeSlice from "./webHomeSlice"
import ClientSlice from "./clientSlice"
import WebSubMenu from "./web/subMenuSlice"
import SellerSlice from "./web/sellerOptionSlice"
import CustConstSlice from "./web/customizeConstructionSlice"
import InsuranceFacilitySlice from "./web/insuranceFacilitySlice"
import LoanFacilitySlice from "./web/loanFacilitySlice"
import FeedbackSlice from "./web/feedbackSlice"
import EnquirySlice from "./web/enquirySlice"
import HotDealsSlice from "./web/hotDealsSlice"


export const reducer = {
    auth: AuthSlice,
    project: ProjectSlice,
    webHome: WebHomeSlice,
    setting: SettingSlice,
    subProject: SubProjectSlice,
    client: ClientSlice,
    about: AboutSlice,
    contact: ContactSlice,
    submenu: SubMenuSlice,
    webSubmenu: WebSubMenu,
    sellerOption: SellerSlice,
    custConst: CustConstSlice,
    insuranceFacility: InsuranceFacilitySlice,
    loanFaciliy: LoanFacilitySlice,
    feedback: FeedbackSlice,
    enquirySlice: EnquirySlice,
    hotDeals: HotDealsSlice
}